import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-lists-20',
  templateUrl: './20.component.html',
  styleUrls: ['./20.component.scss'],
})
export class VbList20Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
